import BaseXMLGenerator from '@/utils/excel/xlsx-tableexport-generator.js'
// import { getOrderID, amountFormat } from '@/utils/filters/formatter.js'
import moment from 'moment'
function amountFormatBySDK (value) {
  return value
  // return amountFormat(value)
}

var XMLGenerator = new BaseXMLGenerator()
XMLGenerator.baseGenerate = XMLGenerator.generate
XMLGenerator.generate = function (vm, datas) {
  var rows = []
  var isActiveIng = (obj) => {
    var now = moment(new Date())
    var started = true
    if (obj.BeginAt != null) started = now.isAfter(obj.BeginAt)
    if (!started) return false

    var finished = false
    if (obj.EndAt != null) finished = now.isAfter(moment(obj.EndAt).add(1, 'days'))
    if (finished) return false

    return true
  }
  for (var dataIdx = 0; dataIdx < datas.length; ++dataIdx) {
    // for (var dataIdx = datas.length - 1; dataIdx >= 0; --dataIdx) {
    let data = datas[dataIdx]
    var row = []

    // '編號', '排序',特價'' '價格', '稅率', '上架日期', '下架日期', '預購商品'
    var specialPrice = ''
    if (data.Tw.Discount && isActiveIng(data.Tw.Discount)) {
      specialPrice = data.Tw.Discount.Price
    }
    row.push(data.ID)
    row.push(data.SortOrder)
    row.push(data.Tw.OriginalPrice)
    row.push(specialPrice)
    row.push({ 1: '應稅', 3: '免稅' }[data.Tw.TaxType] || data.Tw.TaxType)
    row.push(data.Tw.ReleaseAt)
    row.push(data.Tw.CloseAt)
    row.push(data.IsPreOrderProduct ? '是' : '否')
    // '商品名稱', '商品描述', '商品類別', '商品標籤', '內文'
    row.push(data.Tw.Name)
    row.push(data.Tw.Description)
    row.push(data.Tw.Categories.map(o => o.TitleTw).join(', '))
    row.push(data.Tw.Tags.map(o => o.TitleTw).join(', '))
    // row.push('Contents')

    row.push(data.En.Name)
    row.push(data.En.Description)
    row.push(data.En.Categories.map(o => o.TitleEn).join(', '))
    row.push(data.En.Tags.map(o => o.TitleEn).join(', '))
    // row.push('Contents')

    row.push(data.Jp.Name)
    row.push(data.Jp.Description)
    row.push(data.Jp.Categories.map(o => o.TitleJp).join(', '))
    row.push(data.Jp.Tags.map(o => o.TitleJp).join(', '))
    // row.push('Contents')

    rows.push(row)
  }

  let headerList = [
    '編號', '排序', '價格', '特價', '稅率', '上架日期', '下架日期', '預購商品',
    '商品名稱', '商品描述', '商品類別', '商品標籤', // '內文',
    '商品名稱(英文)', '商品描述(英文)', '商品類別(英文)', '商品標籤(英文)', // '內文(英文)',
    '商品名稱(日文)', '商品描述(日文)', '商品類別(日文)', '商品標籤(日文)'// '內文(日文)'
  ]
  let typeList = [
    'string', 'number', 'number', 'number', 'string', 'string', 'string', 'string',
    'string', 'string', 'string', 'string', // 'string',
    'string', 'string', 'string', 'string', // 'string',
    'string', 'string', 'string', 'string'// 'string'
  ]
  return this.baseGenerate(rows, headerList, typeList)
}

export default XMLGenerator
